import actions from '../../actionTypes';

export default trigger => {
  return {
    type: actions.ADDED_TRIGGER,
    trigger
  };
};



// WEBPACK FOOTER //
// ./src/reducers/triggers/actions/addedTrigger.js